var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.myArray),function(page){return _c('button',{key:page,staticClass:"button",class:{activePage: (_vm.curPage==page)},on:{"click":function($event){return _vm.$emit('page-selected',page)}}},[_vm._v(_vm._s(page))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }